export default __webpack_public_path__ + "static/section2-cleaning-5eb955c66f4fda1376e566c981f7a077.webp";